// eslint-disable-next-line import/no-relative-parent-imports
import packageJson from '../../package.json';
import ConfigType from './config';
const packageVersion = packageJson['version'];
const hostname = window.location.hostname;

export const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
export const isBetaHost = hostname === 'app.beta.resurs.com';
export const isAppHost = hostname === 'app.resurs.com';
export const isSEHost = hostname === 'authentication.resurs.com';
export const isNOHost = hostname === 'authentication.resursbank.no';
export const isDKHost = hostname === 'authentication.resursbank.dk';
export const isFIHost = hostname === 'authentication.resursbank.fi';
export const isauthenticationHost =
  isSEHost || isNOHost || isDKHost || isFIHost;
export const isProductionHost = isauthenticationHost || isAppHost;
export const isDevelopmentHost = hostname.endsWith('.d.eks.aws.cld.resurs.com');
export const isIntegrationHost =
  !isProductionHost && !isBetaHost && !isLocalHost && !isDevelopmentHost;

export const isProduction = isProductionHost || isBetaHost;
export const isIntegration = isIntegrationHost;
export const isDev = isDevelopmentHost;

const local = {
  env: 'local',
  apiKey: '59d51b41e42f4f4bb07104371b19d152',
  clientId: '7b84d3f88474f8d3b46e33e3645d95c3',
  //
  // clientId: 'mock',
  signDocumentsClientId: '8e1f2b2b81576611951080be596d67e1',
  enableLog: false,
  clientHost: 'http://localhost:3000',
  bankIdHost: 'http://localhost:8080/api',
  bankIdNoAuthorizeHost: 'auth.current.bankid.no',
  // bankIdHost: 'https://apigw.integration.resurs.com/api/digital_id_service',
  signingPathPrefix: '/mock/demo/signing',
  apm: {
    apmEnvironment: isLocalHost ? 'local' : 'dev',
    apmServiceName: 'authentication-frontend',
    apmServerUrl:
      'https://resurselasticdev.apm.eu-north-1.aws.elastic-cloud.com',
  },
  links: {
    entrypoint:
      'https://apigw.integration.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://apigw.integration.resurs.com/api/unleash/frontend',
    mbidRefresh:
      'https://apigw.integration.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'http://localhost:8086/api/oauth2/token',
    oAuthRedirect: 'http://localhost:8086/api/oauth2/auth',
    oAuthTokenRevoke: 'http://localhost:8086/api/oauth2/token/revoke',
    oAuthPreAuth: 'http://localhost:8086/api/oauth2/preauthorization',
    // oAuthToken: 'https://apigw.integration.resurs.com/api/oauth2/token',
    // oAuthRedirect: 'https://apigw.integration.resurs.com/api/oauth2/auth',
    // oAuthTokenRevoke:
    //   'https://apigw.integration.resurs.com/api/oauth2/token/revoke',
    // oAuthPreAuth:
    //   'https://apigw.integration.resurs.com/api/oauth2/preauthorization',
  },
} as const;

const development = {
  env: 'development',
  apiKey: '1886ddcb2422e942af8e1a72a3ce07a4',
  clientId: '7b84d3f88474f8d3b46e33e3645d95c3',
  signDocumentsClientId: '8e1f2b2b81576611951080be596d67e1',
  enableLog: false,
  clientHost: 'https://authentication-frontend-dev.d.eks.aws.cld.resurs.com',
  bankIdHost: 'https://api.d.eks.aws.cld.resurs.com/api/digital_id_service',
  bankIdNoAuthorizeHost: 'auth.current.bankid.no',
  signingPathPrefix: '/mock/demo/signing',
  apm: {
    apmEnvironment: 'dev',
    apmServiceName: 'authentication-frontend',
    apmServerUrl:
      'https://resurselasticdev.apm.eu-north-1.aws.elastic-cloud.com',
  },
  links: {
    entrypoint:
      'https://api.d.eks.aws.cld.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://api.d.eks.aws.cld.resurs.com/api/unleash/frontend',
    mbidRefresh:
      'https://api.d.eks.aws.cld.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://api.d.eks.aws.cld.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://api.d.eks.aws.cld.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke:
      'https://api.d.eks.aws.cld.resurs.com/api/oauth2/token/revoke',
    oAuthPreAuth:
      'https://api.d.eks.aws.cld.resurs.com/api/oauth2/preauthorization',
  },
} as const;

const integration = {
  env: 'integration',
  apiKey: '1886ddcb2422e942af8e1a72a3ce07a4',
  clientId: '7b84d3f88474f8d3b46e33e3645d95c3',
  signDocumentsClientId: 'cddd83d6d751ea5f05ac0d525c126332',
  clientHost: 'https://authentication.integration.resurs.com',
  enableLog: false,
  bankIdHost: 'https://apigw.integration.resurs.com/api/digital_id_service',
  bankIdNoAuthorizeHost: 'auth.current.bankid.no',
  signingPathPrefix: '/mock/demo/signing',
  apm: {
    apmEnvironment: 'integration',
    apmServiceName: 'authentication-frontend',
    apmServerUrl: 'https://elastic-telemetry.integration.resurs.com',
  },
  links: {
    entrypoint:
      'https://apigw.integration.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://apigw.integration.resurs.com/api/unleash/frontend',
    mbidRefresh:
      'https://apigw.integration.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://apigw.integration.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://apigw.integration.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke:
      'https://apigw.integration.resurs.com/api/oauth2/token/revoke',
    oAuthPreAuth:
      'https://apigw.integration.resurs.com/api/oauth2/preauthorization',
  },
} as const;

const production = {
  env: 'production',
  apiKey: 'ae9f4acc12da1f9da33ebefca07c1548',
  clientId: 'c26f3364bcac01f38da16333a38b5c57',
  signDocumentsClientId: '0533d5e918eee004866458f71d0f3ec1',
  clientHost: 'https://authentication.resurs.com',
  enableLog: false,
  bankIdHost: 'https://apigw.resurs.com/api/digital_id_service',
  bankIdNoAuthorizeHost: 'auth.bankid.no',
  signingPathPrefix: '/signing',
  apm: {
    apmEnvironment: 'prod',
    apmServiceName: 'authentication-frontend',
    apmServerUrl: 'https://elastic-telemetry.resurs.com',
  },
  links: {
    entrypoint:
      'https://apigw.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://apigw.resurs.com/api/unleash/frontend',
    mbidRefresh: 'https://apigw.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://apigw.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://apigw.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke: 'https://apigw.resurs.com/api/oauth2/token/revoke',
    oAuthPreAuth: 'https://apigw.resurs.com/api/oauth2/preauthorization',
  },
} as const;

export const config: ConfigType & {
  env: 'local' | 'development' | 'integration' | 'production';
  clientHost: string;
  sentryDSN: string;
  sentryId: string;
  bankIdHost: string;
} = {
  ...local,
  ...(isDev && development),
  ...(isIntegration && integration),
  ...(isProduction && production),
  clientName: 'authentication-frontend',
  clientVersion: packageVersion,
  clientPlatform: 'WEB',
  chatClientId: 'authentication-frontend',
  requestTimeout: 60000,
  sentryDSN:
    'https://af95996364bd4dabb64dd392dbe4b11e@o566388.ingest.sentry.io/6392096',
  sentryId: '6392096',
};
export {requireConfig, getConfig, setConfig} from './config';
